import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { api } from '../api/client'
import type { Erfassung } from '../api/typen'
import AppRahmen from '../komponenten/AppRahmen'
import ReportInhalt from '../komponenten/ReportInhalt'

/**
 * P10-03: Verifizierungsreport mit Bildern - zur Pruefung vor der Bestellung und zum Abgleich
 * vor Ort beim Umbau. Bewusst einfach gehalten: eine Webansicht, die sich ueber die
 * Druckfunktion des Browsers als PDF sichern laesst. Der Inhalt ist dasselbe Bauteil wie im Buero.
 */
export default function Report() {
  const { erfassungId } = useParams()

  const erfassung = useQuery({
    queryKey: ['erfassung', erfassungId],
    queryFn: () => api.get<Erfassung>(`/api/erfassungen/${erfassungId}`),
  })

  return (
    <AppRahmen
      titel="Verifizierungsreport"
      unter={erfassung.data?.standort}
      zurueck={`/erfassungen/${erfassungId}/ergebnis`}
      pfad={
        erfassung.data
          ? {
              erfassungId: erfassung.data.id,
              standort: erfassung.data.standort,
              versorgungspunktId: null,
              versorgungspunkt: null,
              schrankId: null,
              schrank: null,
            }
          : undefined
      }
      ebene="erfassung"
      pfadZusatz="Verifizierungsreport"
      breit
      fuss={
        <button className="btn btn-primaer nicht-drucken" onClick={() => window.print()}>
          Drucken oder als PDF sichern
        </button>
      }
    >
      {erfassung.isPending && <div className="spinner" />}
      {erfassung.data && <ReportInhalt erfassung={erfassung.data} />}
    </AppRahmen>
  )
}
